import { Link } from '@inertiajs/react'
import { Card } from '@/components/ui/Card'
import { Eye, Clock, User } from 'lucide-react'
import type { HomeArticle } from '@/types'

interface FeaturedArticlesProps {
  articles: HomeArticle[]
}

function FeaturedArticleCard({ article }: { article: HomeArticle }) {
  return (
    <Link
      href={`/content/${article.category_slug}/${article.slug}`}
      className="group block"
    >
      <Card className="h-full hover:shadow-lg hover:border-tessan-primary/30 transition-all">
        {/* Catégorie */}
        <span className="inline-block px-2 py-1 text-xs font-medium bg-tessan-cream text-tessan-primary rounded-full mb-3">
          {article.category_name}
        </span>

        {/* Titre */}
        <h3 className="text-base font-semibold text-text-dark group-hover:text-tessan-primary transition-colors mb-2 line-clamp-2">
          {article.title}
        </h3>

        {/* Extrait */}
        <p className="text-text-gray text-sm mb-4 line-clamp-2">
          {article.excerpt}
        </p>

        {/* Meta */}
        <div className="flex flex-wrap items-center gap-3 text-xs text-text-gray mt-auto">
          <span className="flex items-center gap-1">
            <User className="w-3.5 h-3.5" />
            {article.author.name}
          </span>
          <span className="flex items-center gap-1">
            <Clock className="w-3.5 h-3.5" />
            {article.reading_time} min
          </span>
          <span className="flex items-center gap-1">
            <Eye className="w-3.5 h-3.5" />
            {article.views_count}
          </span>
        </div>
      </Card>
    </Link>
  )
}

export function FeaturedArticles({ articles }: FeaturedArticlesProps) {
  if (articles.length === 0) {
    return null
  }

  return (
    <div className="space-y-4">
      <div className="grid md:grid-cols-3 gap-4">
        {articles.map((article) => (
          <FeaturedArticleCard key={article.id} article={article} />
        ))}
      </div>

      <div className="text-center pt-2">
        <Link
          href="/content"
          className="text-tessan-primary hover:underline text-sm font-medium"
        >
          Voir tous les contenus →
        </Link>
      </div>
    </div>
  )
}
